import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "row justify-content-center" }
const _hoisted_2 = { class: "col-md-10 col-lg-8 col-xl-9 col-xxl-8 col-xxxl-6" }
const _hoisted_3 = { class: "card mb-25 border-0 rounded-0 bg-white authentication-card" }
const _hoisted_4 = { class: "card-body letter-spacing" }
const _hoisted_5 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_6 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_7 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_8 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_9 = { class: "form-check form-check-primary mb-0 fs-md-15 fs-lg-16 text-muted lh-1 mb-15 mb-md-20" }
const _hoisted_10 = ["disabled"]
const _hoisted_11 = {
  key: 0,
  class: "spinner-border",
  role: "status"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _cache[15] || (_cache[15] = _createElementVNode("h4", { class: "text-black fw-bold mb-0 text-center" }, "Devenir Client", -1)),
          _createElementVNode("form", {
            form: "",
            onSubmit: _cache[5] || (_cache[5] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleRegister && _ctx.handleRegister(...args)), ["prevent"]))
          }, [
            _createElementVNode("div", _hoisted_5, [
              _cache[6] || (_cache[6] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Nom complet (*)", -1)),
              _withDirectives(_createElementVNode("input", {
                type: "text",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.name) = $event)),
                class: "form-control shadow-none rounded-0 text-black"
              }, null, 512), [
                [_vModelText, _ctx.form.name]
              ])
            ]),
            _createElementVNode("div", _hoisted_6, [
              _cache[7] || (_cache[7] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Adresse electronique (*) ", -1)),
              _withDirectives(_createElementVNode("input", {
                type: "email",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.email) = $event)),
                class: "form-control shadow-none rounded-0 text-black"
              }, null, 512), [
                [_vModelText, _ctx.form.email]
              ])
            ]),
            _createElementVNode("div", _hoisted_7, [
              _cache[8] || (_cache[8] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Numéro de téléphone (*) ", -1)),
              _withDirectives(_createElementVNode("input", {
                type: "text",
                pattern: "[0-9]+",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.phone) = $event)),
                class: "form-control shadow-none rounded-0 text-black"
              }, null, 512), [
                [_vModelText, _ctx.form.phone]
              ])
            ]),
            _createElementVNode("div", _hoisted_8, [
              _cache[9] || (_cache[9] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Ville (*) ", -1)),
              _withDirectives(_createElementVNode("input", {
                type: "text",
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.city) = $event)),
                class: "form-control shadow-none rounded-0 text-black"
              }, null, 512), [
                [_vModelText, _ctx.form.city]
              ])
            ]),
            _createElementVNode("div", _hoisted_9, [
              _withDirectives(_createElementVNode("input", {
                class: "form-check-input shadow-none",
                type: "checkbox",
                id: "remember-me",
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.status) = $event)),
                "true-value": "1",
                "false-value": "0"
              }, null, 512), [
                [_vModelCheckbox, _ctx.form.status]
              ]),
              _cache[10] || (_cache[10] = _createElementVNode("label", {
                class: "form-check-label",
                for: "remember-me"
              }, [
                _createTextVNode(" J'accepte tous les "),
                _createElementVNode("a", {
                  href: "#",
                  class: "text-decoration-none"
                }, "termes et conditions")
              ], -1))
            ]),
            _createElementVNode("button", {
              class: "default-btn transition border-0 fw-medium text-white rounded-1 fs-md-15 fs-lg-16 bg-success d-block w-100",
              type: "submit",
              disabled: _ctx.load || _ctx.form.status == 0
            }, [
              (_ctx.load)
                ? (_openBlock(), _createElementBlock("div", _hoisted_11, _cache[11] || (_cache[11] = [
                    _createElementVNode("span", { class: "visually-hidden" }, "Loading...", -1)
                  ])))
                : _createCommentVNode("", true),
              _cache[12] || (_cache[12] = _createTextVNode(" S'inscrire ", -1))
            ], 8, _hoisted_10),
            _cache[14] || (_cache[14] = _createElementVNode("span", { class: "d-block text-muted text-center mt-15 mt-md-30 mb-12 mb-md-20 fs-md-15 fs-lg-16" }, " Vous avez déjà un compte ? ", -1)),
            _createVNode(_component_router_link, {
              to: "/login",
              class: "default-btn with-border transition fw-medium rounded-1 fs-md-15 fs-lg-16 d-block w-100 text-decoration-none text-center"
            }, {
              default: _withCtx(() => _cache[13] || (_cache[13] = [
                _createTextVNode(" Se connecter ", -1)
              ])),
              _: 1,
              __: [13]
            })
          ], 32)
        ])
      ])
    ])
  ]))
}